import React, { FC, HTMLProps } from 'react';

import { CurrencyType, formatCurrency } from '../../utils/currency';

interface Props extends HTMLProps<HTMLSpanElement> {
  value?: string | number;
  currencyCode?: CurrencyType;
  prefix?: any;
  postfix?: string;
  className?: string;
}

const CurrencyFormat: FC<Props> = props => {
  const {
    value = 0,
    currencyCode,
    prefix = '',
    postfix = '',
    className = '',
    ...otherProps // TODO: выпилить otherProps и проверить, что никто не использует
  } = props;
  const formattedValue = formatCurrency(value, currencyCode);

  return (
    <span {...otherProps} className={className}>
      {prefix}
      {formattedValue}
      {postfix}
    </span>
  );
};

export default CurrencyFormat;
